export const updateScreenStructure = (screen_structure, screen_structure_field, value) => {
    console.log('value', value);
    if (screen_structure && window.screenStructures) {
        const structureName = screen_structure.split('__')[1];
        const structureField = screen_structure_field.split('__')[1];
        if (!window.screenStructures[structureName]) {
            window.screenStructures[structureName] = {};
        }
        window.screenStructures[structureName][structureField] = value;
        console.log('update screenStructures', value, structureName, structureField);
    }
};
export const getStructureFieldName = (screen_structure, screen_structure_field) => {
    if (screen_structure && screen_structure_field) {
        const structureName = screen_structure.split('__')[1];
        const structureField = screen_structure_field.split('__')[1];
        return { structureName, structureField };
    }
    return { structureName: '', structureField: '' };
};
export const baseUrl = `https://${window.location.hostname}:18080/prod-api`;
